import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { isAdminRole } from "@/lib/roles";

export default function ProtectedRoute({ children, role }) {
  const { user, ready } = useAuth();
  const loc = useLocation();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-sm text-muted-foreground">Loading…</div>
      </div>
    );
  }
  // preserve the intended destination so Login can send the user back (e.g. /insurance)
  if (!user || user === false) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (role === "admin" && !isAdminRole(user.role)) return <Navigate to="/" replace />;
  if (role && role !== "admin" && user.role !== role) return <Navigate to="/" replace />;
  return children;
}
